export const CAIGOU_CHINA_TICKET_PARAM = 'ticket'

export const CAIGOU_CHINA_TICKET_ALIASES = [
  CAIGOU_CHINA_TICKET_PARAM,
  'login_ticket',
  'credential',
  'sso_ticket',
  'auth_code',
  'token',
] as const

/** Resolve the canonical ticket first while retaining compatibility with deployed aliases. */
export function resolveCaigouChinaTicket(search: string) {
  const searchParams = new URLSearchParams(search)
  return CAIGOU_CHINA_TICKET_ALIASES
    .map((paramName) => (searchParams.get(paramName) || '').trim())
    .find(Boolean) || ''
}

/** Remove every accepted credential alias without disturbing route, hash, or unrelated query state. */
export function clearCaigouChinaTicketFromUrl() {
  const url = new URL(window.location.href)
  CAIGOU_CHINA_TICKET_ALIASES.forEach((paramName) => {
    url.searchParams.delete(paramName)
  })
  window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`)
}
